export function groupTrafficRoom(businessId, groupId) {
  return `business_${businessId}_group_${groupId}`;
}

export function joinGroupTrafficRoom(socket, businessId, groupId) {
  if (!socket || !businessId || !groupId) return;
  socket.emit("join_group_traffic", { businessId, groupId });
}

export function leaveGroupTrafficRoom(socket, businessId, groupId) {
  if (!socket || !businessId || !groupId) return;
  socket.emit("leave_group_traffic", { businessId, groupId });
}
